import propz from 'propz';

function getUserScope(user: any): string {
  const schoolId = propz.get(user, ['activeSchoolId'], propz.get(user, ['activeSchool', 'id'], 'school'));
  const userId = propz.get(user, ['userId'], propz.get(user, ['id'], propz.get(user, ['profile', 'id'], 'user')));
  const role = propz.get(user, ['activeRole'], 'role');

  return `${schoolId}:${userId}:${role}`;
}

export function getColumnVisibilityStorageKey(user: any, viewKey: string): string {
  return `sit.columnVisibility:${getUserScope(user)}:${viewKey}`;
}

export function loadHiddenColumns(user: any, viewKey: string, defaultFields: string[] = []): string[] {
  if (typeof window === 'undefined') return [...defaultFields];

  try {
    const storedValue = window.localStorage.getItem(getColumnVisibilityStorageKey(user, viewKey));
    if (storedValue === null) return [...defaultFields];

    const value = JSON.parse(storedValue);
    return Array.isArray(value) ? value.filter(field => typeof field === 'string') : [...defaultFields];
  } catch (error) {
    return [...defaultFields];
  }
}

export function saveHiddenColumns(user: any, viewKey: string, fields: string[]): void {
  if (typeof window === 'undefined') return;

  try {
    window.localStorage.setItem(getColumnVisibilityStorageKey(user, viewKey), JSON.stringify(fields));
  } catch (error) {
    // Column preferences are non-critical when storage is unavailable.
  }
}
